import { Box } from '@mui/material';
import { Login } from '../auth/login/login';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { ServiceCarousel } from '../carousel/serviceCarousel';
import { NewsCarousel } from '../carousel/newsCarousel';
import { useTranslation } from 'react-i18next';
import { RouterParam } from '../../helpers/routerParam';
import useGetParameter from '../../hooks/useGetParameter';
import { Navigate } from 'react-router';
import { updateDocumentTitle } from '../../helpers/documentHelper';
import { DiscountBanner } from '../banner/discountBanner';
import { useRouteNavigator } from '../../routes/useRouteNavigator';
import { appStyleMode, IsSewingCompany } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { Banner } from '../banner/banner';
import detergentsBannerLogo from '../../logo/detergentsBanner.png';
import detergentsBannerLogoSmall from '../../logo/detergentsBannerSmall.png';

export function WebsiteHomePage() {
  const isUserLoggedIn: boolean = useAppSelector((state: RootState) => state.authState.isLoggedIn);
  const routeNavigator = useRouteNavigator();
  const { t } = useTranslation();
  const pageId = useGetParameter(RouterParam.PageId);
  updateDocumentTitle();

  const isOldRulesPage = () => {
    return pageId === '11';
  };

  return isOldRulesPage() ? (
    <Navigate to={routeNavigator.getRulesPath()} replace />
  ) : (
    <Box sx={{ mt: '10px', p: '10px', backgroundColor: 'white', borderRadius: '15px' }}>
      <ServiceCarousel />
      <NewsCarousel />
      {appStyleMode === AppStyle.Website && (
        <>
          {/* <Banner
            image={detergentsBannerLogo}
            smallImage={detergentsBannerLogoSmall}
            url={routeNavigator.getGoodsPath()}
          /> */}
          {/* <DiscountBanner /> */}
        </>
      )}
      <Box
        sx={{
          textTransform: 'uppercase',
          textAlign: 'center',
          color: 'black',
          fontSize: '26px',
        }}
      >
        {IsSewingCompany ? t('info:sewingHomePageTitle') : t('info:homePageTitle')}
      </Box>
      {!isUserLoggedIn && <Login hideTitle />}
    </Box>
  );
}
